import { StateCreator } from "zustand";
import { isNewAuthorization } from "../authorizationStore";

export enum ESMSFormState {
  initial,
  validating,
  validated,
  submitting,
  submitted,
}

export interface ISMSFormSlice {
  smsCode: string;
  smsFormState: ESMSFormState;
  errorMessage: string;
  consents: string[];
  setSMSCode: (smsCode: string) => void;
  clearSMSForm: () => void;
  setSMSFormState: (state: ESMSFormState) => void;
  setErrorMessage: (errorMessage: string) => void;
  setConsents: (consents: string[]) => void;
}

/**
 * Contains all information about sms form.
 */
export const smsFormSliceCreator: StateCreator<ISMSFormSlice> = set => ({
  smsCode: "",
  errorMessage: "",
  smsFormState: ESMSFormState.initial,
  consents: [],
  setSMSCode: (smsCode) => {
    set(() => ({
      smsCode: isNewAuthorization() ? smsCode.replace(/\D/g, "").slice(0, 6) : smsCode.replace(/\D|.{5,}/ig, ""),
    }));
  },
  clearSMSForm: () => {
    set(() => ({
      smsCode: "",
      smsFormState: ESMSFormState.initial,
      errorMessage: "",
      consents: [],
    }));
  },
  setSMSFormState: (state: ESMSFormState) => {
    set(() => ({ smsFormState: state }));
  },
  setErrorMessage: (message) => {
    set(() => ({ errorMessage: message }));
  },
  setConsents: (consents) => {
    set(() => ({ consents }));
  },
});
